// extracted by mini-css-extract-plugin
export default {"contents":"kI-z","sectionHeading":"lI-z"};